import { Box } from '@mui/material';

import withOptionsWidget, { WithOptionsWidgetProps } from 'components/widgetParts/withOptionsWidget';
import ImageSettings, { defaultSettings } from './ImageSettings';

interface ImageWidgetData {
  imageBase64?: string
}

function Image(props: WithOptionsWidgetProps) {
  const currentState = {...defaultSettings, ...props.widget?.data?.settings};
  const imageWidgetData = props.widget?.data as ImageWidgetData;

  return (
    <>
      {imageWidgetData?.imageBase64 &&
        <Box
          sx={{ 
            height: "100%",
            backgroundRepeat: "no-repeat",
            backgroundImage: `url(${imageWidgetData?.imageBase64})`,
            backgroundSize: currentState.imageSize,
            backgroundPosition: currentState.imagePosition,
            backgroundColor: currentState.backgroundColor
          }}>
        </Box>}
        {props.settingsDialogIsOpen && <ImageSettings {...props} />}
    </>
  )
}

export default withOptionsWidget(Image, {hasSettingsDialog: true})
